jQuery(document).ready(function(){

  jQuery('.productView-moreItem #product-add-to-cart').attr('disabled', '');  
  jQuery('.productView-stickyCart').hide();
  
  jQuery( "#practitioner-name" ).change(function() {
    if(jQuery(this).val() == "") {
      jQuery('.productView-moreItem #product-add-to-cart').attr('disabled', '');
      jQuery('.productView-stickyCart').hide();
    } else {
      jQuery('.productView-moreItem #product-add-to-cart').removeAttr('disabled');
      jQuery('.productView-stickyCart').show();
    }
  });
    
});
